import { render, staticRenderFns } from "./ApplicantMessageReservationCanceledToApplicant.vue?vue&type=template&id=6dccc692"
import script from "./ApplicantMessageReservationCanceledToApplicant.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageReservationCanceledToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports